import React from "react";
import { Row, Col, Tabs } from "antd";

const { TabPane } = Tabs;

export default function DncpHeader(props) {
  return (
    <Row>
      <Col span={6}>
        <img
          src="/gobierno_nacional.png"
          alt="DNCP"
          style={{ paddingTop: 10, height: 70 }}
        />
      </Col>
      <Col span={15}>
        <Tabs
          defaultActiveKey="entidades_proveedores"
          onChange={props.onTabChange}
        >
          <TabPane
            tab="Entidades + Proveedores Adjudicados"
            key="entidades_proveedores"
          ></TabPane>
          {/* <TabPane tab="Proveedores Cooferentes" key="proveedores"></TabPane> */}
        </Tabs>
      </Col>
      <Col span={3}>
        <img
          src="/dncp.png"
          alt="Nacional"
          style={{ paddingTop: 5, height: "100%", width: "100%" }}
        />
      </Col>
    </Row>
  );
}
